<div class="modal-body p-5 d-none d-md-block">
  <div class="d-flex justify-content-between align-items-center">
    <!-- Contenido de la derecha -->
    <div class="d-flex flex-column right-content mt-5">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <img src="assets/images/Gif-loading.gif" alt="gif">
        <p class="text text-center font-medium-roboto">
          Estamos evaluando tu solicitud de préstamo. Nos tomará unos minutos.
        </p>
      </div>
      <div class="d-flex important-content align-items-start p-2 mt-5">
        <img src="assets/images/svg/important.svg" alt="important" class="important">
        <p class="ms-2 mb-0">
          En caso de demora o de cierre de esta ventana, <strong>la solicitud seguirá en curso.</strong>
        </p>
      </div>
    </div>

    <!-- Carrusel -->
    <div class="carousel-container ms-4">
      <ngx-slick-carousel class="carousel mt-4" #slickModal="slick-carousel" [config]="slideConfig"
                          (afterChange)="onSlideChange($event)">
        <div ngxSlickItem *ngFor="let slide of data" class="slide">
          <div>
            <img src="assets/images/svg/help.svg" alt="help">
          </div>
          <div class="mt-2">
            <p class="text font-medium-roboto">{{ slide.question }}</p>
            <p class="text font-regular-roboto" [innerHTML]="slide.answer"></p>
          </div>
        </div>
      </ngx-slick-carousel>

      <div class="btn-web mt-3">
        <button class="custom-prev btn" (click)="slickModal.slickPrev()"><img src="assets/images/svg/arrow-left.svg"
                                                                              alt="prev"></button>
        <button class="custom-next btn" (click)="slickModal.slickNext()"><img src="assets/images/svg/arrow-right.svg"
                                                                              alt="next"></button>
      </div>
    </div>
  </div>
</div>

<div class="modal-body-responsive d-md-none">
  <div class="d-flex flex-column align-items-center">
    <!-- Contenido de la derecha -->
    <div class="d-flex flex-column right-content mt-5">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <img src="https://acceso.com.pe/wp-content/uploads/2024/10/Cargando.gif" alt="gif">
        <p class="text text-center font-medium-roboto">
          Estamos evaluando tu solicitud de préstamo. Nos tomará unos minutos.
        </p>
      </div>
    </div>

    <!-- Carrusel -->
    <div class="carousel-container ">
      <ngx-slick-carousel class="carousel mt-4" #slickModal2="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let slide of data" class="slide">
          <div>
            <img src="assets/images/svg/help.svg" alt="help">
          </div>
          <div class="mt-4">
            <p class="text font-medium-roboto">{{ slide.question }}</p>
            <p class="text font-regular-roboto">{{ slide.answer }}</p>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
    <div class="btn-responsive">
      <button class="custom-prev btn" (click)="slickModal2.slickPrev()"><img src="assets/images/svg/arrow-left.svg"
                                                                             alt="prev"></button>
      <button class="custom-next btn" (click)="slickModal2.slickNext()"><img src="assets/images/svg/arrow-right.svg"
                                                                             alt="next"></button>
    </div>

    <div class="d-flex important-content align-items-start p-2 mt-2">
      <img src="assets/images/svg/important.svg" alt="important" class="important">
      <p class="ms-2 mb-0">
        En caso de demora o de cierre de esta ventana, <strong>la solicitud seguirá en curso.</strong>
      </p>
    </div>
  </div>
</div>



